import VendorsCookieConsent from './cookie-consent/cookie-consent';
import VendorsFancybox      from './fancybox/fancybox';
import VendorsOdometer      from './odometer/odometer';
import VendorsIframeResizer from './iframe-resizer/iframe-resizer';

const vendors = () => {
	/* eslint-disable no-console */
	// if (processEnv === 'development') {
	// 	console.log('Vendors');
	// }
	/* eslint-enable no-console */

	VendorsCookieConsent();
	VendorsFancybox();
	VendorsIframeResizer();
	// VendorsOdometer();
};

export default vendors;
